module.exports = __webpack_public_path__ + "img/lotus-white.8f992b4f.png";